import { ReactElement } from 'react';
import { Modal } from './Modal';
import { NutritionLabel } from '../../../models/product.types';

type Props = {
  isOpen: boolean;
  title: string;
  subtitle: string;
  nutritionLabel: NutritionLabel;
  hasIngredients: boolean;
  onClose: () => void;
}

export function NutritionLabelModal({
  isOpen,
  title,
  subtitle,
  nutritionLabel,
  hasIngredients,
  onClose,
}: Props): ReactElement {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      labelledBy="nutrition-label-title"
      classNames=""
      closeButtonAriaLabel="Close nutrition label"
    >
      <>
        <div className="c-recipe__content">
          <span id="nutrition-label-title" className="visually-hidden">
            {`${title} nutrition facts`}
          </span>
          <h3 aria-hidden="true" className="c-order__active-content c-recipe__title u-text--center">
            {title.toUpperCase()}
            <span className="c-recipe__subtitle">{subtitle}</span>
          </h3>
        </div>
        <hr />
        <div className="u-text--center">
          <img
            src={nutritionLabel.x1.url}
            srcSet={`${nutritionLabel.x1.url} 1x, ${nutritionLabel.url} 2x"`}
            alt="Nutrition label"
          />
        </div>
        {hasIngredients && (
          <div className="u-text u-text--xs p-4">
            <br />
            <p>
              Manufactured on equipment shared with tree nuts, peanut, sesame, wheat, soy, egg,
              milk,
              fish, and shellfish.
            </p>
            <strong>WARNING: </strong>
            Consuming this product can expose you to chemicals including lead, which is known to the
            State of California to cause cancer and birth defects or other reproductive harm.
            For more information go to
            <br />
            <a href="https://www.P65Warnings.ca.gov/food">www.P65Warnings.ca.gov/food</a>
            .
            <br />
            <br />
            Purple Carrot, 460 Hillside Ave, Needham, MA 02494
          </div>
        )}
      </>
    </Modal>
  );
}
